// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-homepage[data-v-0effa67d]{padding-left:0}.modelEssay[data-v-0effa67d]{display:flex;align-items:baseline;cursor:pointer}.modelEssay>span[data-v-0effa67d]:first-child{font-size:1rem!important;text-decoration:underline}.modelEssay .icon-jiantou1[data-v-0effa67d]{font-size:1.2rem;padding:0 .3rem}.modelEssay .icon-jiantou11[data-v-0effa67d]{font-size:1rem;padding:0 .3rem}", ""]);
// Exports
module.exports = exports;
